import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
const LoginIsland = () => {
    const [loginData, setLoginData] = useState(null);
    useEffect(() => {
        // Получаем данные из DOM
        const container = document.getElementById('login-providers-root');
        if (!container) {
            return;
        }
        const error = container.dataset.error || null;
        const providersJson = container.dataset.providers || '';
        let providers = [];
        try {
            if (providersJson) {
                providers = JSON.parse(providersJson);
            }
        }
        catch (e) {
            console.error('Failed to parse providers JSON:', e);
        }
        setLoginData({
            error,
            providers
        });
    }, []);
    if (!loginData) {
        return null;
    }
    const { error, providers } = loginData;
    // Отображаем сообщение об ошибке
    const renderError = () => {
        if (!error)
            return null;
        let message = '';
        switch (error) {
            case 'blocked':
                message = 'Вход отклонён: аккаунт заблокирован.';
                break;
            case 'site':
                message = 'Вход недоступен на этом домене.';
                break;
            case 'provider':
                message = 'Выбранный способ входа недоступен.';
                break;
            default:
                message = 'Не удалось выполнить вход. Попробуйте ещё раз.';
        }
        return (_jsx("div", { className: "alert alert-danger", children: message }));
    };
    return (_jsxs("div", { children: [renderError(), providers.length > 0 && (_jsx("div", { className: "d-grid gap-2 mb-4", children: providers.map((provider) => (_jsxs("a", { className: "btn btn-outline-primary", href: `/oauth2/authorization/${provider.code}`, role: "button", children: ["\u0412\u043E\u0439\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 ", provider.displayName] }, provider.code))) }))] }));
};
export default LoginIsland;
